import type { HTMLAttributes } from 'react';

import classNames from 'classnames';

import styles from './ContentWidth.module.css';

export type ContentWidthAlignment = 'start' | 'center' | 'end';

export interface ContentWidthProps extends HTMLAttributes<HTMLElement> {
  /** Number of thirds the content takes up */
  fr?: 1 | 2 | 3;
  /** Enable default column padding */
  withPadding?: boolean;
  /** Add a gutter to the right */
  withGutter?: boolean;
  /** Align the content using margins. Works only when `fr={1}`. */
  alignSelf?: ContentWidthAlignment;
}

/**
 * Render a `div` HTML element whose width is expressed in thirds of the
 * container's width.
 *
 * @deprecated Use {@link Grid} to create grids. See the
 *   {@link https://corgi-x.tfd.engineering/components/contentwidth | ContentWidth docs}
 *   for more details.
 * @see https://corgi-x.tfd.engineering/components/contentwidth
 */
export function ContentWidth(props: ContentWidthProps) {
  const {
    fr = 1,
    className,
    children,
    withPadding,
    withGutter,
    alignSelf = 'start',
    ...elementProps
  } = props;
  return (
    <div
      className={classNames(
        styles.content,
        { [styles.withPadding]: withPadding, [styles.withGutter]: withGutter },
        styles[`fr-${fr}`],
        styles[alignSelf],
        className
      )}
      {...elementProps}
    >
      {children}
    </div>
  );
}
